//
//
//
//
//
//
//
//
//
//
//

import BuildingItem from '@/components/business/whole_building_item'
import list_log from '@/common/user_log_mixins/list_log'
export default {
    data () {
        return {
            type: 'find_building'
        }
    },
    components: {
        BuildingItem
    },
    mixins: [
        list_log
    ],
    props: {
        list: {
            type: Array
        }
    }
}
